import {UserRole} from '@/services/tmm';
import {createSlice} from '@reduxjs/toolkit';

export enum Airline {
  SIA = 'SIA',
  TGW = 'TGW',
  MAS = 'MAS',
  FJI = 'FJI',
  ACML1 = 'ACML1'
}

export interface UserState {
  user?: any;
  airline: string;
  token: string;
  role: UserRole;
}

const initialState: UserState = {
  user: undefined,
  airline: Airline.SIA,
  token: '',
  role: UserRole.PILOT
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    logout(state) {
      state.user = undefined;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    setRole(state, action) {
      state.role = action.payload;
    },
    setAirline(state, action) {
      state.airline = action.payload;
    }
  }
});

export const {logout, setToken, setRole, setUser, setAirline} =
  userSlice.actions;
export default userSlice.reducer;
